/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyMailToken200Response
 */
export interface VerifyMailToken200Response {
    /**
     * ステータス
     * @type {number}
     * @memberof VerifyMailToken200Response
     */
    status: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof VerifyMailToken200Response
     */
    message: string;
    /**
     * パスワード更新トークン (3:パスワード変更の場合のみ返却)
     * @type {string}
     * @memberof VerifyMailToken200Response
     */
    passwordToken?: string;
}

/**
 * Check if a given object implements the VerifyMailToken200Response interface.
 */
export function instanceOfVerifyMailToken200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function VerifyMailToken200ResponseFromJSON(json: any): VerifyMailToken200Response {
    return VerifyMailToken200ResponseFromJSONTyped(json, false);
}

export function VerifyMailToken200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyMailToken200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'passwordToken': !exists(json, 'password_token') ? undefined : json['password_token'],
    };
}

export function VerifyMailToken200ResponseToJSON(value?: VerifyMailToken200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'password_token': value.passwordToken,
    };
}

